import { Navigate, useLocation } from 'react-router-dom'
import AuthService from 'services/auth'

export default function CompanyRoute ({ children }) {
  const location = useLocation ()
  const isSigned = AuthService.isSigned ()
  const isCompany = AuthService.isCompany ()

  if (isSigned && isCompany) {
    return children
  }

  return (
    <Navigate
      to='/company/login'
      state={{ from: location }}
      replace
    />
  )
} 
